import { createDevLogger } from '../../utils';

const logger = createDevLogger({ namespace: 'PageViewHelper' });

export const PAGEVIEW_SENT_EVENT = 'analytics:pageview-sent';

export interface PageViewPayload {
  pageTemplate: string;
  locale: string;
  pageLocation?: string;
  pageTitle?: string;
  isFirstLoad?: boolean;
  pathname?: string;
}

/**
 * Push a page_view event with common context to GTM/GA.
 */
export function pushPageView({
  pageTemplate,
  locale,
  pageLocation,
  pageTitle,
  isFirstLoad,
  pathname,
}: PageViewPayload): void {
  if (typeof window === 'undefined') return;

  window.dataLayer = window.dataLayer || [];

  const payload = {
    event: 'page_view',
    page_template: pageTemplate,
    content_language: locale,
    ...(pageLocation ? { page_location: pageLocation } : {}),
    ...(pageTitle ? { page_title: pageTitle } : {}),
  };

  logger.info('Pushing page_view', { pathname, ...payload, isFirstLoad });
  window.dataLayer.push(payload);

  document.dispatchEvent(
    new CustomEvent(PAGEVIEW_SENT_EVENT, {
      detail: { pageTemplate, locale, pathname },
    })
  );
}
